<app-sidenav></app-sidenav>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="square-jelly-box" [fullScreen]="true">
    <p > Loading... </p>
  </ngx-spinner>